import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import clientforms from 'services/clientforms.service';

export default function AuthenticatedFormSignature({clientId, submissionId, answerId}) {
  const token = useSelector(state => state.auth?.token);
  const [state, setState] = useState({source: '', status: 'loading'});
  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    let source = '';
    setState({source:'', status:'loading'});
    clientforms.signatureContent({clientId, submissionId, answerId, signal:controller.signal})
      .then(({data}) => {
        if (!(data instanceof Blob) || !data.type.startsWith('image/')) throw new Error('Invalid signature');
        if (!active) return;
        source = URL.createObjectURL(data);
        setState({source,status:'ready'});
      })
      .catch(() => { if (active) setState({source:'',status:'error'}); });
    return () => { active=false; controller.abort(); if(source) URL.revokeObjectURL(source); };
  },[clientId,submissionId,answerId,token]);
  if(state.status !== 'ready') return <span role="status">{state.status === 'error' ? 'Signature unavailable' : 'Loading signature'}</span>;
  return <img src={state.source} alt="Signature" onError={() => setState({source:'',status:'error'})} style={{display:'block',maxWidth:'100%',height:'auto',maxHeight:240,objectFit:'contain'}}/>;
}
const idType = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);
AuthenticatedFormSignature.propTypes = {clientId:idType.isRequired, submissionId:idType.isRequired, answerId:idType.isRequired};
